import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { commonFormMessages } from 'azshared';
import React from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';

export interface AppDateInputProps {
  label?: string;
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  placeholder?: string;
  onChange?: (date: any | null, value?: any) => void;
  disableFuture?: boolean;
  disabled?: boolean;
}

export const AppDateInput = (props: AppDateInputProps) => {
  const { formatMessage } = useIntl();
  const {
    label,
    value,
    minDate,
    maxDate,
    placeholder = formatMessage(commonFormMessages.placeholderDateInput),
    onChange,
    disableFuture = true,
    disabled
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value ? dayjs(value) : null}
        maxDate={maxDate ? dayjs(maxDate) : null}
        minDate={minDate ? dayjs(minDate) : null}
        onChange={onChange}
        disableFuture={disableFuture}
        disabled={disabled}
        slotProps={{
          textField: {
            placeholder: placeholder
            // The AppInputWrapper is not directly compatible with the new DatePicker.
            // I will need to investigate how to use a custom input component with the new DatePicker.
            // For now, I will use the default text field.
          }
        }}
        format='DD/MM/YYYY'
      />
    </LocalizationProvider>
  );
};
